export const siteInfo = {
  name: '黑料聚合网',
  tagline: '聚合51黑料网、91黑料网、17黑料网等热门数字黑料子品牌入口',
  description: '一站浏览51黑料最新、91黑料吃瓜、17黑料视频、718黑料合集等数字系列黑料内容。提供最全的黑料入口导航与每日更新的热门吃瓜资讯。',
  url: 'https://51heiliao.com',
  founded: '2019',
  email: 'contact@51heiliao.com',
  brandIntro: '黑料聚合网创立于2019年，是国内领先的数字黑料内容聚合平台。我们致力于为用户提供一站式的黑料资讯浏览体验，聚合51黑料网、91黑料网、17黑料网等头部平台的优质内容，让用户无需在多个网站之间来回切换，即可获取最全面、最及时的黑料资讯。',
  reputation: '经过多年的深耕运营，黑料聚合网已经积累了超过500万的注册用户，日均页面浏览量超过200万次。平台以其内容全面性、更新及时性和信息准确性赢得了用户的广泛信赖。我们始终坚持「真实、快速、全面」的内容理念，为用户提供高质量的数字黑料内容服务。',
  contactInfo: {
    email: 'contact@51heiliao.com',
    wechat: 'heiliao_official',
    cooperation: 'coop@51heiliao.com',
  },
  stats: {
    users: '500万+',
    dailyVisits: '200万+',
    articles: '10万+',
    platforms: '8+',
  },
  timeline: [
    { year: '2019', event: '黑料聚合网正式上线，首批聚合51黑料网内容' },
    { year: '2020', event: '新增91黑料网内容聚合，用户突破100万' },
    { year: '2021', event: '上线17黑料网视频聚合功能' },
    { year: '2022', event: '推出718黑料合集专区，实现全平台内容覆盖' },
    { year: '2023', event: '完成移动端全面优化，日活用户突破50万' },
    { year: '2024', event: '引入AI智能推荐系统，用户体验大幅提升' },
    { year: '2025', event: '注册用户突破500万，成为行业领先平台' },
    { year: '2026', event: '持续优化内容生态，巩固行业领先地位' },
  ],
  faqs: [
    {
      question: '黑料聚合网是什么？',
      answer: '黑料聚合网是一个综合性的数字黑料内容聚合平台，为读者聚合51黑料网、91黑料网、17黑料网等热门平台的最新内容。用户可以通过我们的平台一站式浏览来自多个黑料来源的资讯、视频和爆料内容，无需在多个网站之间来回切换。',
    },
    {
      question: '如何获取51黑料最新地址？',
      answer: '您可以在黑料聚合网的51黑料专区找到51黑料网的最新可用地址。我们会持续更新和验证51黑料最新入口，确保用户能够顺畅访问。建议收藏我们的地址发布页，以便及时获取最新地址更新。',
    },
    {
      question: '718黑料合集包含哪些内容？',
      answer: '718黑料合集是我们推出的跨平台内容聚合专区，汇集了51黑料网、91黑料网、17黑料网等多个平台的精选内容。通过718黑料合集入口，用户可以一次性浏览来自不同来源的黑料精华资源，实现真正的一站式内容获取。',
    },
    {
      question: '黑料聚合网的内容是否免费？',
      answer: '是的，黑料聚合网的所有内容对用户完全免费开放。我们通过内容聚合的方式，为用户提供便捷的浏览体验，不收取任何费用。用户可以直接访问各专区查看最新内容。',
    },
    {
      question: '如何联系我们？',
      answer: '您可以通过以下方式联系我们：邮件 contact@51heiliao.com，或关注我们的官方渠道获取最新动态。商务合作请发送邮件至 coop@51heiliao.com。',
    },
  ],
};